import $, { type } from 'jquery';
   
$(function() {
    var urlString = window.location.href;
    var paramString = urlString.split('?')[1];
    var queryString = new URLSearchParams(paramString);
    for(let pair of queryString.entries()) {
        $("#"+pair[0]).val(pair[1]);
    }
    if(queryString != ""){

        $('html,body').animate({
            scrollTop: $(".cwm-fa-form-filters").offset().top - 150},
            '2000');
    }
    
    $(".cwm-fa-form-filters select.cwm-filter-data").change(function(){
     var url = window.location.href;
        var currentUrl = new URL(url);
        currentUrl.searchParams.set($(this).attr("id"), $(this).val());
        window.location.replace(currentUrl);
        if($("#eventCategory").val() == "connection-event"){
            let index_val = document.getElementById("eventType").selectedIndex = "1";
            let queryString = currentUrl.search;  // get url parameters
            let params = new URLSearchParams(queryString);  // create url search params object
            params.delete('eventType');  // delete eventtype parameter if it exists, in case you change the dropdown more then once
 document.location.href = "?" + params.toString(); // refresh the page with new url
        }
        else{
            let index_val = document.getElementById("eventType").selectedIndex = "1";
            let queryString1 = currentUrl.search;  // get url parameters
            let params1 = new URLSearchParams(queryString1);  // create url search params objec
            params1.delete('eventType');  // delete eventtype parameter if it exists, in case you change the dropdown more then once
            params1.append('eventType', index_val.val());
            document.location.href = "?" + params1.toString(); // refresh the page with new url;
        }
    });
});

$(window).on('load', function () {
    if($("#eventCategory").val() == "connection-event"){
        $("#eventType").prop('disabled',true);      
    }

    else {
        $("#eventType").prop('disabled',false);
    }
});   
  


// WEBPACK FOOTER //
// ./components/cwm-event-filter/scripts/cwm-event-filter.js